var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFacebookIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 29 29"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#746366",
  fillRule: "evenodd",
  d: "M28.367 14.739C28.367 7.032 22.158.787 14.5.787 6.842.787.633 7.033.633 14.738c0 6.964 5.071 12.736 11.7 13.782v-9.749h-3.52v-4.033h3.52v-3.073c0-3.497 2.07-5.428 5.238-5.428 1.517 0 3.104.272 3.104.272v3.434h-1.749c-1.722 0-2.26 1.075-2.26 2.178v2.617h3.846l-.614 4.033h-3.231v9.75c6.629-1.047 11.7-6.819 11.7-13.783Z",
  clipRule: "evenodd"
})));
export { SvgFacebookIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/facebook-icon.9e32fbb60b52965bf05f.svg";